import React from "react";

import * as Components from "../../components";

import { PhaseQuestion } from "./phase.question";

import "./index.scss"
import { AssociationFailed } from "./phase.association.failed";
import { Renavigation } from "./phase.renavigation";
import { UserCheck } from "./phase.user.check";


type Phase = "question" | "user-check" | "renavigation" | "association-failed"

const YumSSOIdSelfService = () => {
    const [phase, setPhase] = React.useState<Phase>("question")
    const [selfServiceRequest, setSelfServiceRequest] = React.useState<{ YumSSOId: string, HelpDescEmail: string }>(null)
    React.useEffect(() => {
        fetch("YumSSOSelfService/GetYumSSOSelfServiceRequestData").then(async (response) => {
            var data = await response.json()
            setSelfServiceRequest(data);
        }).catch(stopProcess)
    }, [])

    const startUserCheck = () => {
        setPhase("user-check")
    }
    const stopProcess = () => {
        window.location.href = "/login";
    }
    const onUserVerified = (verified: boolean) => {
        if (verified) {
            setPhase("renavigation")
            setTimeout(() => {
                window.location.href = "/yum/login"
            }, 5000);
        } else {
            setPhase("association-failed")
        }
    }
    const phaseUI = React.useMemo(() => {
        switch (phase) {
            case "question":
                return <PhaseQuestion yumSSOId={selfServiceRequest?.YumSSOId} onYes={startUserCheck} onNo={stopProcess} />
            case "user-check":
                return <UserCheck yumSSOId={selfServiceRequest?.YumSSOId} onVerify={onUserVerified} onBackToLogin={stopProcess} helpDescEmail={selfServiceRequest.HelpDescEmail} />
            case "renavigation":
                return <Renavigation yumSSOId={selfServiceRequest?.YumSSOId} />
            case "association-failed":
                return <AssociationFailed onBackToLogin={stopProcess} helpDescEmail={selfServiceRequest.HelpDescEmail} />
            default:
                return <>UI not suppoerted</>
        }

    }, [phase, selfServiceRequest])

    if (selfServiceRequest == null)
        return <></>

    if (phase === "renavigation")
        return <Components.LayoutBlock verticalAlign='center' align='center' className='view yum-sso-self-service ' style={{ width: 360, height: 160, padding: "42px 32px" }}>
            {phaseUI}
        </Components.LayoutBlock >

    return <Components.LayoutBlock verticalAlign='center' align='center' className='view yum-sso-self-service ' style={{ width: 360, height: 480, padding: "42px 32px" }}>
        <Components.LayoutBlock style={{ alignSelf: 'stretch', marginBottom: 32 }}>
            <Components.LayoutBlock inline fill className='header'>
                Tracks SSO Self-Service
            </Components.LayoutBlock>
        </Components.LayoutBlock >
        {phaseUI}
    </Components.LayoutBlock >
}





export default YumSSOIdSelfService;